import { useState, useEffect } from "react";
import FormData from "form-data";
import * as ReactBootStrap from "react-bootstrap";


import axios from "axios";

function PanOCR() {
  const [cardData, setCardData] = useState({
    Document_type: "",
    "item.details.aadhaar.ismasked": "",
    "item.details.aadhaar.masked_value": "frfrf",
    "item.details.aadhaar.value": "",
    "item.details.dob": "",
    "item.details.name.value": "",
    "item.details.gender.value": "",
    status: "",
  });
  const [img, setImg] = useState();
  const [loading , setLoading] = useState(true)


  useEffect(() => {
    console.log("ththth", cardData);
  }, [cardData]);

  const onChange = (e) => {
    var file = e.target.files[0];
    let base64String = "";

    var reader = new FileReader();
    console.log("next");

    reader.onload = function () {
      base64String = reader.result.replace("data:", "").replace(/^.+,/, "");
      console.log("base64String", base64String);
      setImg("b " + base64String);
    };
    reader.readAsDataURL(file);
  };

  const submit = () => {
    setLoading(false);
    setCardData({
      Document_type: "",
      "item.details.aadhaar.ismasked": "",
      "item.details.aadhaar.masked_value": "frfrf",
      "item.details.aadhaar.value": "",
      "item.details.dob": "",
      "item.details.name.value": "",
      "item.details.gender.value": "",
      status: "",
    });
    var data = new FormData();
    data.append("ImageByte", img);
    var config = {
      method: "post",
      url: "https://mv0gthimo7.execute-api.ap-south-1.amazonaws.com/default/panocrservice",
      headers: {
        "x-api-key": "4OxiRZbTqMaKwo6xqnimq9dJ6f5V3Hel12baxxmi",
        authorizationToken: "Y9K8mqTyY8sSgHy2",
      },
      data: data,
    };

    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        setCardData(response.data);
        setLoading(true)

      })
      .catch(function (error) {
        setLoading(true)

        alert("Something went wrong with server");
        console.log(error);
      });
  };

  useEffect(() => {}, [cardData]);

  return (
    <div>
      <div class="container containerBoreder " id="pan">
        <h2 class="pageTitle">PAN OCR</h2>
        <div class="row">
            <div class="col-4">
              <input type="file" onChange={onChange} />
            </div>
            {loading?(<div class="col-4">
              <button class="btn btn-primary" onClick={submit}>
                Submit
              </button>
            </div>) :<ReactBootStrap.Spinner animation="border" />}
          </div>
        <br />
        <table class="table">
          <tbody>
            <tr>
              <th width="25%">Status</th>
              <td>{cardData.status}</td>
            </tr>
            <tr>
              <th>PAN No</th>
              <td>{cardData.pan_no}</td>
            </tr>
            <tr>
              <th>Name</th>
              <td>{cardData.name ? "" + cardData["name"] : ""}</td>
            </tr>
            <tr>
              <th>Father Name</th>
              <td>{cardData.father_name}</td>
            </tr>
              <tr>
              <th>Date of Birth</th>
              <td>{cardData.date_of_birth}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default PanOCR;
